module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9Ceo7"))).then(() => parcelRequire('f4eak'));